import { Order } from "../order";
import { PaymentTransactionRequestModel } from "./PaymentTransactionRequestModel";

export class CreditReferenceTransactionRequestModel {
    paymentTransaction: PaymentTransactionRequestModel;
    order: Order;

    constructor() {
        this.paymentTransaction = new PaymentTransactionRequestModel();
        this.order = new Order();
    }
}